import { FileError } from "react-dropzone";
import { FILE_NAME_REG_EXP } from "../../../../constants/FileUploadNameRegex";
import { getFileNameWithoutExtension } from "../FileUtil/FileUtil";

export const extendedFileNameValidator = (
  file: File,
  rejectedFileNames?: string[],
): FileError | FileError[] | null => {
  const nameWithoutExtension = getFileNameWithoutExtension(file.name);

  if (!nameWithoutExtension.match(FILE_NAME_REG_EXP)) {
    return {
      code: "invalid-file-name",
      message: `Please check the file name is not empty and does not contain any special characters`,
    };
  }

  if (!rejectedFileNames) {
    return null;
  }

  const fileIndex = rejectedFileNames.findIndex(
    (rejectedFileName) => rejectedFileName === file.name,
  );

  if (fileIndex !== -1) {
    return {
      code: "duplicate-file-name",
      message: `A file with name ${file.name} has already been selected`,
    };
  }

  return null;
};
